/* Misguided Chrome theme */
(() => {
  const MG = window.MG || {};
  const T = MG.t || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const fill = (s, vars) => String(s || '').replace(/{{\s*(\w+)\s*}}/g, (_, k) => vars[k] ?? '');

  /* ---------- money ---------- */
  function money(cents) {
    const fmt = MG.moneyFormat || '${{amount}}';
    const n = Number(cents) / 100;
    const group = (num, dec, th, ds) => {
      const [i, d] = num.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (d ? ds + d : '');
    };
    const out = fmt.replace(/{{\s*(\w+)\s*}}/, (_, k) => {
      switch (k) {
        case 'amount_no_decimals': return group(n, 0, ',', '.');
        case 'amount_with_comma_separator': return group(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(n, 2, "'", '.');
        default: return group(n, 2, ',', '.');
      }
    });
    const tmp = document.createElement('div');
    tmp.innerHTML = out;
    return tmp.textContent;
  }

  /* ---------- drop mode ---------- */
  const dropAt = MG.drop && MG.drop.at ? Date.parse(MG.drop.at) : NaN;
  function isDrop() { return document.body.classList.contains('is-drop'); }
  function checkDropOpen() {
    if (!MG.drop || !MG.drop.on || !MG.drop.autoOpen || isNaN(dropAt)) return;
    if (Date.now() >= dropAt) document.body.classList.remove('is-drop');
  }
  checkDropOpen();

  /* ---------- countdown ---------- */
  const pad = n => String(n).padStart(2, '0');
  function tickClocks() {
    $$('[data-countdown]').forEach(el => {
      const at = Date.parse(el.dataset.countdown);
      const d = isNaN(at) ? 0 : Math.max(0, at - Date.now()) / 1000;
      $('[data-d]', el).textContent = pad(Math.floor(d / 86400));
      $('[data-h]', el).textContent = pad(Math.floor(d % 86400 / 3600));
      $('[data-m]', el).textContent = pad(Math.floor(d % 3600 / 60));
      $('[data-s]', el).textContent = pad(Math.floor(d % 60));
    });
    checkDropOpen();
  }
  if ($('[data-countdown]')) { tickClocks(); setInterval(tickClocks, 1000); }

  /* ---------- toast ---------- */
  let toastTimer;
  function toast(msg) {
    const t = $('[data-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('on'), 2800);
  }

  /* ---------- overlays ---------- */
  const scrim = $('[data-scrim]');
  let lastFocus = null;
  function openLayer(name) {
    const el = $(`[data-drawer="${name}"]`);
    if (!el) return false;
    $$('[data-drawer].on').forEach(o => { if (o !== el) closeLayer(o, true); });
    lastFocus = document.activeElement;
    el.classList.add('on');
    el.setAttribute('aria-hidden', 'false');
    scrim && scrim.classList.add('on');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => {
      const f = $('[data-search-input]', el) || $('[data-close]', el);
      f && f.focus();
    }, 80);
    return true;
  }
  function closeLayer(el, keepScrim) {
    el.classList.remove('on');
    el.setAttribute('aria-hidden', 'true');
    if (!keepScrim) {
      scrim && scrim.classList.remove('on');
      document.documentElement.style.overflow = '';
      lastFocus && lastFocus.focus && lastFocus.focus();
    }
  }
  function closeAll() { $$('[data-drawer].on').forEach(el => closeLayer(el)); }
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const name = opener.dataset.open;
      if (name === 'cart' && document.body.classList.contains('template-cart')) return;
      if (openLayer(name)) {
        e.preventDefault();
        if (name === 'cart') refreshCart();
        if (name === 'search') runSearch();
      }
      return;
    }
    if (e.target.closest('[data-close]') || e.target === scrim) closeAll();
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });

  /* ---------- header ---------- */
  const bar = $('[data-header]');
  if (bar) addEventListener('scroll', () => bar.classList.toggle('stuck', scrollY > 120), { passive: true });

  /* ---------- cart ---------- */
  const linesEl = $('[data-cart-lines]');
  async function getCart() {
    const r = await fetch(`${MG.routes.cart}.js`, { headers: { Accept: 'application/json' } });
    return r.json();
  }
  function renderCart(cart) {
    $$('[data-cart-count]').forEach(n => { n.textContent = cart.item_count; n.hidden = cart.item_count === 0; });
    const sub = $('[data-cart-subtotal]');
    if (sub) sub.textContent = money(cart.total_price);
    const co = $('[data-checkout]');
    if (co) co.disabled = cart.item_count === 0;
    if (!linesEl) return;
    if (!cart.items.length) { linesEl.innerHTML = `<p class="empty">${esc(T.empty)}</p>`; return; }
    linesEl.innerHTML = cart.items.map(i => {
      const img = i.image ? `<img src="${esc(i.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2'))}" alt="" loading="lazy">` : '';
      const variant = i.variant_title && !/default title/i.test(i.variant_title) ? `<span class="meta">${esc(i.variant_title)}</span>` : '';
      return `<div class="line">
        <a class="th shot" href="${esc(i.url)}">${img}</a>
        <div>
          <h5 class="cond"><a href="${esc(i.url)}">${esc(i.product_title)}</a></h5>${variant}
          <div class="qty">
            <button type="button" aria-label="${esc(T.decrease)}" data-line-key="${esc(i.key)}" data-qty="${i.quantity - 1}">&minus;</button>
            <span>${i.quantity}</span>
            <button type="button" aria-label="${esc(T.increase)}" data-line-key="${esc(i.key)}" data-qty="${i.quantity + 1}">+</button>
          </div>
        </div>
        <span>${esc(money(i.final_line_price))}</span>
      </div>`;
    }).join('');
  }
  async function refreshCart() { try { renderCart(await getCart()); } catch (e) { /* keep server render */ } }
  linesEl && linesEl.addEventListener('click', async e => {
    const b = e.target.closest('[data-line-key]');
    if (!b) return;
    linesEl.classList.add('busy');
    try {
      const r = await fetch(`${MG.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: b.dataset.lineKey, quantity: Number(b.dataset.qty) })
      });
      const cart = await r.json();
      if (!r.ok) throw new Error(cart.description || 'error');
      renderCart(cart);
    } catch (err) {
      toast(err.message && err.message !== 'error' ? err.message : T.error);
    } finally {
      linesEl.classList.remove('busy');
    }
  });

  async function addToCart(variantId, title, btn) {
    if (isDrop()) return;
    const label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = T.adding; }
    try {
      const r = await fetch(`${MG.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || T.error);
      await refreshCart();
      openLayer('cart');
      toast(fill(T.added, { title }));
    } catch (err) {
      toast(err.message || T.error);
    } finally {
      if (btn) { btn.disabled = false; btn.innerHTML = label; }
    }
  }

  /* ---------- variant picking (shared by product page and quick view) ---------- */
  function variantFor(product, selected) {
    return product.variants.find(v => v.options.every((o, i) => o === selected[i])) || null;
  }
  function optionAvailable(product, selected, index, value) {
    return product.variants.some(v => v.available && v.options[index] === value &&
      v.options.every((o, i) => i === index || i > index || o === selected[i]));
  }

  /* product page */
  const root = $('[data-product-root]');
  if (root) {
    const product = JSON.parse($('[data-product-json]', root).textContent);
    const form = $('[data-product-form]', root);
    const input = $('[data-variant-input]', root);
    const addBtn = $('[data-add]', root);
    const priceEl = $('[data-price]', root);
    const sets = $$('.opt', root);
    const initial = product.variants.find(v => String(v.id) === input.value) || product.variants[0];
    const selected = initial ? initial.options.slice() : [];
    const multi = sets.length > 0;
    const sizeIndex = product.options.findIndex(o => /size/i.test(o.name || o));
    // with a size option, make shoppers choose their size rather than defaulting to the first
    if (multi && sizeIndex > -1 && product.variants.length > 1 && !location.search.includes('variant=')) selected[sizeIndex] = null;

    function sync() {
      sets.forEach((fs, idx) => {
        $$('button', fs).forEach(b => {
          b.setAttribute('aria-pressed', String(b.dataset.value === selected[idx]));
          b.classList.toggle('na', !optionAvailable(product, selected, idx, b.dataset.value));
        });
      });
      const v = selected.includes(null) ? null : variantFor(product, selected);
      const openLabel = $('.open-only', addBtn);
      if (!v) {
        addBtn.disabled = true;
        openLabel.textContent = selected.includes(null) ? T.selectSize : T.soldOut;
        return;
      }
      input.value = v.id;
      addBtn.disabled = !v.available || isDrop();
      openLabel.textContent = v.available ? T.add : T.soldOut;
      priceEl.innerHTML = v.price === 0 ? 'Price coming soon' : (v.compare_at_price > v.price ? `<s>${esc(money(v.compare_at_price))}</s> ` : '') + esc(money(v.price));
      if (v.featured_media) {
        const m = $(`[data-media-id="${v.featured_media.id}"]`, root);
        if (m && matchMedia('(min-width: 861px)').matches) m.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' });
      }
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url);
    }
    sets.forEach((fs, idx) => fs.addEventListener('click', e => {
      const b = e.target.closest('button[data-value]');
      if (!b) return;
      selected[idx] = b.dataset.value;
      sync();
    }));
    form.addEventListener('submit', e => {
      e.preventDefault();
      if (!input.value || addBtn.disabled) return;
      addToCart(Number(input.value), product.title, addBtn);
    });
    if (multi) sync(); else if (isDrop()) addBtn.disabled = true;
  }

  /* quick view */
  const qv = $('[data-drawer="quick"]');
  let qvProduct = null, qvSel = [];
  async function openQuick(handle) {
    try {
      const r = await fetch(`${MG.routes.root.replace(/\/$/, '')}/products/${encodeURIComponent(handle)}.js`);
      if (!r.ok) throw new Error();
      qvProduct = await r.json();
    } catch (e) { location.href = `${MG.routes.root.replace(/\/$/, '')}/products/${handle}`; return; }
    const p = qvProduct;
    $('[data-qv-title]', qv).textContent = p.title;
    $('[data-qv-type]', qv).textContent = p.type || '';
    $('[data-qv-link]', qv).href = p.url || `/products/${p.handle}`;
    const img = p.featured_image ? `<img src="${esc(p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_900x$1$2'))}" alt="${esc(p.title)}">` : '';
    $('[data-qv-media]', qv).innerHTML = img;
    const single = p.variants.length === 1;
    qvSel = single ? p.variants[0].options.slice() : p.options.map(() => null);
    $('[data-qv-options]', qv).innerHTML = single ? '' : p.options.map((o, idx) =>
      `<fieldset class="opt" data-qv-idx="${idx}"><legend class="lbl">${esc(o.name || o)}</legend><div class="sizes">${
        (o.values || [...new Set(p.variants.map(v => v.options[idx]))]).map(val => `<button type="button" data-value="${esc(val)}" aria-pressed="false">${esc(val)}</button>`).join('')
      }</div></fieldset>`).join('');
    // a single-value option (e.g. one colour) is pre-selected
    p.options.forEach((o, idx) => {
      const vals = o.values || [...new Set(p.variants.map(v => v.options[idx]))];
      if (vals.length === 1) qvSel[idx] = vals[0];
    });
    syncQuick();
    openLayer('quick');
  }
  function syncQuick() {
    const p = qvProduct;
    $$('[data-qv-idx]', qv).forEach(fs => {
      const idx = Number(fs.dataset.qvIdx);
      $$('button', fs).forEach(b => {
        b.setAttribute('aria-pressed', String(b.dataset.value === qvSel[idx]));
        b.classList.toggle('na', !optionAvailable(p, qvSel, idx, b.dataset.value));
      });
    });
    const v = qvSel.includes(null) ? null : variantFor(p, qvSel);
    const btn = $('[data-qv-add]', qv);
    const note = $('[data-qv-note]', qv);
    const shown = v || p.variants[0];
    $('[data-qv-price]', qv).innerHTML = shown.price === 0 ? 'Price coming soon' : (shown.compare_at_price > shown.price ? `<s>${esc(money(shown.compare_at_price))}</s> ` : '') + esc(money(shown.price));
    if (isDrop()) { btn.disabled = true; btn.textContent = T.comingSoon; note.textContent = T.locked; return; }
    note.textContent = '';
    if (!v) { btn.disabled = true; btn.textContent = T.selectSize; return; }
    btn.disabled = !v.available;
    btn.textContent = v.available ? T.add : T.soldOut;
  }
  if (qv) {
    $('[data-qv-options]', qv).addEventListener('click', e => {
      const b = e.target.closest('button[data-value]');
      if (!b) return;
      qvSel[Number(b.closest('[data-qv-idx]').dataset.qvIdx)] = b.dataset.value;
      syncQuick();
    });
    $('[data-qv-add]', qv).addEventListener('click', e => {
      const v = variantFor(qvProduct, qvSel);
      if (v) addToCart(v.id, qvProduct.title, e.currentTarget);
    });
  }
  document.addEventListener('click', e => {
    const q = e.target.closest('[data-quick]');
    if (!q || !qv) return;
    e.preventDefault();
    openQuick(q.dataset.quick);
  });

  /* ---------- predictive search ---------- */
  const sInput = $('[data-search-input]');
  const sResults = $('[data-search-results]');
  let sTimer, sCtrl;
  async function runSearch() {
    if (!sInput || !sResults) return;
    const q = sInput.value.trim();
    if (!q) { sResults.innerHTML = ''; return; }
    sCtrl && sCtrl.abort();
    sCtrl = new AbortController();
    try {
      const r = await fetch(`${MG.routes.search}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`, { signal: sCtrl.signal, headers: { Accept: 'application/json' } });
      const data = await r.json();
      const items = (data.resources && data.resources.results && data.resources.results.products) || [];
      sResults.innerHTML = items.length ? items.map(p => `<a href="${esc(p.url)}">${p.image ? `<img src="${esc(p.image)}" alt="" loading="lazy">` : ''}<span class="t cond">${esc(p.title)}</span><span>${esc(money(Math.round(parseFloat(p.price) * 100)))}</span></a>`).join('')
        : `<p>${esc(fill(T.noResults, { terms: q }))}</p>`;
    } catch (e) { if (e.name !== 'AbortError') sResults.innerHTML = ''; }
  }
  sInput && sInput.addEventListener('input', () => { clearTimeout(sTimer); sTimer = setTimeout(runSearch, 180); });

  /* ---------- collection sort ---------- */
  $$('[data-sort]').forEach(s => s.addEventListener('change', () => {
    const url = new URL(location.href);
    url.searchParams.set('sort_by', s.value);
    url.searchParams.delete('page');
    location.href = url.toString();
  }));

  /* ---------- logo tilt ---------- */
  const tilts = $$('[data-tilt]');
  if (tilts.length && !reduce && matchMedia('(pointer:fine)').matches) {
    addEventListener('pointermove', e => {
      const x = e.clientX / innerWidth - .5, y = e.clientY / innerHeight - .5;
      tilts.forEach(t => { t.style.transform = `perspective(1400px) rotateY(${x * 6}deg) rotateX(${-y * 4}deg)`; });
    }, { passive: true });
  }

  /* ---------- liquid chrome field ---------- */
  let playing = !reduce;
  const pauseBtns = $$('[data-pause]');
  function syncPause() {
    pauseBtns.forEach(b => {
      b.innerHTML = playing
        ? '<svg viewBox="0 0 12 12" aria-hidden="true"><rect x="2" y="1" width="3" height="10"/><rect x="7" y="1" width="3" height="10"/></svg>'
        : '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M3 1l8 5-8 5z"/></svg>';
      b.setAttribute('aria-label', playing ? T.pause : T.play);
    });
  }
  pauseBtns.forEach(b => b.addEventListener('click', () => { playing = !playing; syncPause(); }));
  syncPause();

  $$('[data-chrome]').forEach(c => {
    const gl = c.getContext('webgl', { antialias: false });
    if (!gl) return;
    const vs = 'attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';
    const fs = `precision highp float;uniform vec2 r;uniform float t;uniform vec2 m;
      float h(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}
      float n(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);return mix(mix(h(i),h(i+vec2(1,0)),f.x),mix(h(i+vec2(0,1)),h(i+vec2(1,1)),f.x),f.y);}
      float fbm(vec2 p){float v=0.,a=.5;for(int i=0;i<4;i++){v+=a*n(p);p=p*2.03+vec2(1.7,9.2);a*=.5;}return v;}
      float H(vec2 p){vec2 q=vec2(fbm(p+t*.025),fbm(p+vec2(5.2,1.3)-t*.02));return fbm(p+1.8*q+m*.35);}
      void main(){vec2 uv=(gl_FragCoord.xy-.5*r)/r.y;vec2 p=uv*1.3;float e=.004;
        float a=H(p);vec3 N=normalize(vec3(H(p+vec2(e,0))-a,H(p+vec2(0,e))-a,e*1.1));
        vec3 R=reflect(vec3(0,0,-1),N);
        float band=sin(R.y*6.+R.x*1.5+a*5.)*.5+.5;
        float env=pow(band,6.)+smoothstep(.3,1.,R.y)*.25;
        vec3 col=mix(vec3(0.),vec3(.9,.91,.93),env);
        col+=vec3(1.)*pow(max(dot(N,normalize(vec3(.3,.6,1.))),0.),60.)*.5;
        col*=.34*smoothstep(1.3,.2,length(uv));
        gl_FragColor=vec4(col,1.);}`;
    const sh = (type, src) => { const o = gl.createShader(type); gl.shaderSource(o, src); gl.compileShader(o); return o; };
    const pr = gl.createProgram();
    gl.attachShader(pr, sh(gl.VERTEX_SHADER, vs));
    gl.attachShader(pr, sh(gl.FRAGMENT_SHADER, fs));
    gl.linkProgram(pr);
    if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) return;
    gl.useProgram(pr);
    gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    const loc = gl.getAttribLocation(pr, 'p');
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    const ur = gl.getUniformLocation(pr, 'r'), ut = gl.getUniformLocation(pr, 't'), um = gl.getUniformLocation(pr, 'm');
    let mx = 0, my = 0, tx = 0, ty = 0, vis = true, time = 0, last = performance.now();
    addEventListener('pointermove', e => { tx = e.clientX / innerWidth - .5; ty = e.clientY / innerHeight - .5; }, { passive: true });
    new IntersectionObserver(es => { vis = es[0].isIntersecting; }).observe(c);
    function size() {
      const d = Math.min(devicePixelRatio, 1.5) * .6;
      c.width = Math.max(1, c.clientWidth * d);
      c.height = Math.max(1, c.clientHeight * d);
      gl.viewport(0, 0, c.width, c.height);
    }
    size();
    addEventListener('resize', size);
    function draw() {
      mx += (tx - mx) * .03; my += (ty - my) * .03;
      gl.uniform2f(ur, c.width, c.height);
      gl.uniform1f(ut, time);
      gl.uniform2f(um, mx, -my);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    }
    function frame(now) {
      const dt = Math.min(.1, (now - last) / 1000);
      last = now;
      if (playing && !document.hidden) { time += dt; if (vis) draw(); }
      requestAnimationFrame(frame);
    }
    draw();
    requestAnimationFrame(frame);
  });
})();
